/* Colorland v10 product page (sections/cl10-pdp.liquid). Ports the prototype's product.html / item.html
   script to real data: gallery counter / dots / thumbnails, variant picker, quantity, Buy now (add + checkout),
   Add to cart (Ajax + toast), gift-wrap + battery add-ons, live-parity delivery promise (cut-off countdown),
   share, photo zoom (hover magnifier + full-screen viewer), sold-out
   "Notify me" (Simpll back-in-stock, WhatsApp fallback), alt-strip analytics, recently viewed.
   Runs after DOMContentLoaded so window.CL (assets/cl10.js, also deferred) exists. */
(function () {
  'use strict';
  function T(k, en) { var d = window.CL10_T; return (d && d[k]) || en; }
  var started = false;
  function start() {
    if (started) return; started = true;
    var root = document.querySelector('[data-pdp]');
    if (!root) return;
    var CL = window.CL || {};
    var data = {};
    try { data = JSON.parse(document.querySelector('[data-pdp-json]').textContent); } catch (e) {}
    var variants = data.variants || [];
    var form = root.querySelector('[data-pdp-form]');
    var vidInput = form && form.querySelector('[data-vid]');
    var current = variants.filter(function (v) { return vidInput && String(v.id) === vidInput.value; })[0] || variants[0];
    var money = CL.money || function (c) { return 'AED ' + (c / 100).toLocaleString('en-US'); };
    var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ---- gallery ---- */
    var s = root.querySelector('[data-slides]'), gi = document.getElementById('gi');
    var dots = root.querySelectorAll('.dots i'), th = root.querySelectorAll('.thumbs-d button');
    var slides = s ? Array.prototype.slice.call(s.children) : [];
    function idx() { return s && s.clientWidth ? Math.round(s.scrollLeft / s.clientWidth) : 0; }
    function mark(i) {
      if (gi) gi.textContent = i + 1;
      dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
      th.forEach(function (b, k) { if (k === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
    }
    /* while a thumbnail-driven scroll animates, keep the target marked (otherwise the ring steps through every slide it passes) */
    var lock = -1, lockT;
    function unlock() { if (lock < 0) return; lock = -1; clearTimeout(lockT); mark(idx()); }
    function go(i, smooth) { if (!s) return; i = Math.max(0, Math.min(slides.length - 1, i)); lock = i; clearTimeout(lockT); lockT = setTimeout(unlock, 900); s.scrollTo({ left: s.clientWidth * i, behavior: smooth && !reduce ? 'smooth' : 'auto' }); mark(i); }
    if (s) {
      var tick = false;
      s.addEventListener('scroll', function () { if (tick) return; tick = true; requestAnimationFrame(function () { tick = false; if (lock < 0) mark(idx()); else if (idx() === lock && Math.abs(s.scrollLeft - s.clientWidth * lock) < 2) unlock(); }); }, { passive: true });
      s.addEventListener('scrollend', unlock);
      s.addEventListener('pointerdown', unlock, { passive: true });
      s.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); go(idx() + 1, true); } else if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx() - 1, true); } });
    }
    th.forEach(function (b) { b.addEventListener('click', function () { go(+b.dataset.go, true); }); });

    /* ---- prices / state ---- */
    function plain(c) { return money(c).replace(/^AED\s*/, ''); }
    var elPrice = root.querySelector('[data-price]'), elCmp = root.querySelector('[data-compare]'), elSave = root.querySelector('[data-save]');
    var elQ = root.querySelector('[data-quarter]'), elPct = root.querySelector('[data-pct]'), elFree = root.querySelector('[data-free]');
    var bar = document.getElementById('buybar');
    var barPrice = bar && bar.querySelector('[data-bar-price]'), barNote = bar && bar.querySelector('[data-bar-note]');
    var gift = root.querySelector('[data-giftrow]'), batt = root.querySelector('[data-battrow]');
    var etaOn = root.querySelector('[data-eta-on]'), etaOff = root.querySelector('[data-eta-off]'), sdd = root.querySelector('[data-sameday]');
    var qty = 1, qn = document.getElementById('qn'), qIn = form && form.querySelector('[data-qty-input]');

    function render(v) {
      if (!v) return;
      var pct = v.compare > v.price ? Math.floor((v.compare - v.price) * 100 / v.compare) : 0, deal = pct >= 10;
      if (elPrice) elPrice.textContent = plain(v.price);
      if (elCmp) { elCmp.hidden = !deal; elCmp.textContent = deal ? money(v.compare) : ''; }
      if (elSave) { elSave.hidden = !deal; elSave.textContent = deal ? T('pdp_save', 'Save') + ' ' + money(v.compare - v.price) : ''; }
      if (elQ) elQ.textContent = money(Math.floor(v.price / 4));
      if (elPct) { elPct.hidden = !deal; elPct.textContent = deal ? '-' + pct + '%' : ''; }
      if (elFree) elFree.hidden = v.price < (data.freeFrom || 0);
      if (barPrice) barPrice.textContent = money(v.price);
      if (barNote) barNote.innerHTML = deal ? '<s>' + money(v.compare) + '</s> · -' + pct + '%' : (!v.available ? T('pdp_sold_out', 'Sold out') : (data.same ? T('pdp_same_day', 'Same-day') : T('pdp_in_stock', 'In stock')));
      document.querySelectorAll('[data-pdp-buy]').forEach(function (b) {
        if (b.type === 'submit') { b.disabled = !v.available; b.textContent = v.available ? T('pdp_buy_now', 'Buy now') : T('pdp_sold_out', 'Sold out'); } else b.hidden = !v.available;
      });
      document.querySelectorAll('[data-pdp-add]').forEach(function (b) { b.hidden = !v.available; });
      document.querySelectorAll('[data-pdp-notify]').forEach(function (b) { b.hidden = v.available; });
      if (gift) gift.hidden = !v.available;
      if (batt) batt.hidden = !v.available;
      if (etaOn) etaOn.hidden = !v.available;
      if (etaOff) etaOff.hidden = !!v.available;
      if (sdd) sdd.hidden = !v.available;
      if (sdd && v.sku) {
        /* keep the WhatsApp message's SKU + price on the selected variant */
        try {
          var u = new URL(sdd.href), msg = u.searchParams.get('text') || '';
          msg = /^SKU: .*$/m.test(msg) ? msg.replace(/^SKU: .*$/m, 'SKU: ' + v.sku) : msg;
          msg = msg.replace(/AED [\d,.]+/, 'AED ' + plain(v.price));
          sdd.href = u.origin + u.pathname + '?text=' + encodeURIComponent(msg);
        } catch (e) {}
      }
      if (vidInput) vidInput.value = v.id;
      qty = Math.min(qty, v.max || 99); setQty(qty);
    }
    function setQty(n) {
      var max = (current && current.max) || 99;
      qty = Math.max(1, Math.min(max, n));
      if (qn) qn.textContent = qty;
      if (qIn) qIn.value = qty;
      root.querySelectorAll('[data-q]').forEach(function (b) { b.disabled = (+b.dataset.q < 0 && qty <= 1) || (+b.dataset.q > 0 && qty >= max); });
    }
    root.querySelectorAll('[data-q]').forEach(function (b) { b.addEventListener('click', function () { setQty(qty + +b.dataset.q); }); });
    setQty(1);

    /* ---- variant picker (real options; most products have one variant) ---- */
    var opts = root.querySelector('[data-options]');
    if (opts && variants.length > 1) {
      var sel = current.options.slice();
      function find(o) { return variants.filter(function (v) { return v.options.every(function (x, i) { return x === o[i]; }); })[0]; }
      function paintOptions() {
        opts.querySelectorAll('.sw').forEach(function (b) {
          var pos = +b.dataset.pos, on = b.dataset.value === sel[pos];
          if (on) { b.setAttribute('aria-current', 'true'); b.setAttribute('aria-checked', 'true'); } else { b.removeAttribute('aria-current'); b.setAttribute('aria-checked', 'false'); }
          var test = sel.slice(); test[pos] = b.dataset.value;
          var v = find(test), ok = !!(v && v.available);
          b.classList.toggle('out', !ok);
          var sm = b.querySelector('small');
          if (!ok && !sm) { sm = document.createElement('small'); sm.textContent = T('pdp_sold_out', 'Sold out'); b.appendChild(sm); } else if (ok && sm) sm.remove();
        });
        opts.querySelectorAll('[data-opt-cur]').forEach(function (el) { el.textContent = sel[+el.getAttribute('data-opt-cur')]; });
      }
      opts.addEventListener('click', function (e) {
        var b = e.target.closest('.sw'); if (!b) return;
        sel[+b.dataset.pos] = b.dataset.value;
        var v = find(sel);
        if (!v) { /* combination doesn't exist: take the first variant with this value */
          v = variants.filter(function (x) { return x.options[+b.dataset.pos] === b.dataset.value; })[0];
          if (v) sel = v.options.slice();
        }
        if (!v) return;
        current = v; paintOptions(); render(v);
        if (v.media) { var k = slides.findIndex(function (el) { return el.getAttribute('data-media-id') === String(v.media); }); if (k > -1) go(k, true); }
        try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString()); } catch (err) {}
      });
      paintOptions();
    }
    render(current);

    /* ---- add / buy ---- */
    function items() {
      var list = [{ id: Number(vidInput.value), quantity: qty }];
      // Add-on chips, linked to the toy the way the cart expects (snippets/cl10-giftrow, cl10-battrow):
      // wrap / bow → _cl_gift=item, batteries → _cl_gift=batt (both per unit, _cl_for = toy variant); card → _cl_gift=card, one per order.
      if (gift && !gift.hidden) root.querySelectorAll('[data-gift-opt][aria-pressed=true]').forEach(function (c) {
        var v = Number(c.getAttribute('data-v')), k = c.getAttribute('data-gift-opt'), t = data.title || '';
        if (!v) return;
        if (k === 'card' && CL.lastCart && CL.lastCart.items.some(function (i) { return i.properties && i.properties._cl_gift === 'card'; })) return; // one card per order
        if (k === 'card') list.push({ id: v, quantity: 1, properties: { _cl_gift: 'card' } });
        else list.push({ id: v, quantity: qty, properties: { For: t, _cl_gift: 'item', _cl_for: String(vidInput.value) } });
      });
      var bc = batt && root.querySelector('[data-batt]');
      if (bc && bc.checked && bc.value && !batt.hidden) list.push({ id: Number(bc.value), quantity: qty, properties: { For: data.title || '', _cl_gift: 'batt', _cl_for: String(vidInput.value) } });
      return list;
    }
    function add(btn, then) {
      if (!current || !current.available) return;
      btn && btn.setAttribute('aria-busy', 'true');
      var R = (window.CL10 && window.CL10.routes) || {}, base = (R.root || '/').replace(/\/$/, '');
      var gm = root.querySelector('[data-gift-msg]');
      var msg = gm && !gm.hidden ? gm.value.trim() : ''; // saved after the add, so the cart exists first
      fetch(base + '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items() }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { return msg ? fetch(base + '/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Gift card message': msg } }) }).catch(function () {}) : null; })
        .then(function () { btn && btn.removeAttribute('aria-busy'); then(); })
        .catch(function (err) { btn && btn.removeAttribute('aria-busy'); if (CL.toast) CL.toast((err && typeof err.description === 'string' && err.description) || T('pdp_add_error', 'Could not add this item. Please try again.')); });
    }
    function toCart() { if (CL.refreshCart) CL.refreshCart(); if (CL.toast) CL.toast(T('pdp_added_to_cart', 'Added to cart') + ' · <a href="' + ((window.CL10 && CL10.routes && CL10.routes.cart) || '/cart') + '">' + T('pdp_view_cart', 'View cart') + '</a>'); }
    function toCheckout() { var R = (window.CL10 && window.CL10.routes) || {}; location.href = (R.root || '/').replace(/\/$/, '') + '/checkout'; }
    function trackBuy(source) {
      try { (function () { window.dataLayer = window.dataLayer || []; window.dataLayer.push(arguments); })('event', 'cl_buy_now_' + source, { send_to: 'G-SJGLT1SPTV', item_id: vidInput && vidInput.value }); } catch (e) {}
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); trackBuy('pdp'); add(form.querySelector('[data-pdp-buy]'), toCheckout); });
    document.querySelectorAll('[data-pdp-buy]').forEach(function (b) { if (b.type !== 'submit') b.addEventListener('click', function () { trackBuy('sticky'); add(b, toCheckout); }); });
    document.querySelectorAll('[data-pdp-add]').forEach(function (b) { b.addEventListener('click', function () { add(b, toCart); }); });

    /* ---- Delivery promise: the live PDP's rule and wording (pdp-section clt-eta), recomputed every 5 s ----
       "Order within 2 hrs 30 mins, get it by Mon, 12 Oct". Shop time zone (data-tz, e.g. +0400) whatever the
       shopper's clock; N business days with the data-skip weekdays (0 = Sunday) not counted; orders before the
       cutoff on a business day are processed today, otherwise the next business day. The countdown shows only
       when beating the cutoff gives an earlier date, and only within 24h. */
    var etaText = root.querySelector('[data-eta-text]');
    if (etaText) {
      var eTz = etaText.getAttribute('data-tz') || '+0400';
      var eTzMs = (eTz.charAt(0) === '-' ? -1 : 1) * (parseInt(eTz.substr(1, 2), 10) * 60 + parseInt(eTz.substr(3, 2), 10)) * 60000;
      if (isNaN(eTzMs)) eTzMs = 4 * 3600000;
      var cutParts = (etaText.getAttribute('data-cutoff') || '15:30').split(':');
      var cutMin = (parseInt(cutParts[0], 10) || 0) * 60 + (parseInt(cutParts[1], 10) || 0);
      var maxDays = parseInt(etaText.getAttribute('data-max'), 10) || 2;
      var skip = (etaText.getAttribute('data-skip') || '0').split(',').map(function (x) { return parseInt(x, 10); }).filter(function (x) { return !isNaN(x); });
      var EDAY = 86400000;
      var isBiz = function (d) { return skip.indexOf(d.getUTCDay()) === -1; };
      var addBiz = function (d, n) { d = new Date(d.getTime()); while (n > 0) { d = new Date(d.getTime() + EDAY); if (isBiz(d)) n--; } return d; };
      var nextBiz = function (d) { d = new Date(d.getTime()); var g = 0; while (!isBiz(d) && g++ < 7) d = new Date(d.getTime() + EDAY); return d; };
      var isAr = /^ar/i.test(document.documentElement.lang || '');
      var arFmt = null;
      if (isAr) { try { arFmt = new Intl.DateTimeFormat('ar-AE-u-nu-latn', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' }); } catch (e) { arFmt = null; } }
      var fmt = function (d) { if (arFmt) return arFmt.format(d); return ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][d.getUTCDay()] + ', ' + d.getUTCDate() + ' ' + ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][d.getUTCMonth()]; };
      var renderEta = function () {
        var now = Date.now(), shopNow = new Date(now + eTzMs);
        var today = new Date(Date.UTC(shopNow.getUTCFullYear(), shopNow.getUTCMonth(), shopNow.getUTCDate()));
        var minsNow = shopNow.getUTCHours() * 60 + shopNow.getUTCMinutes();
        var processDay = (isBiz(today) && minsNow < cutMin) ? today : nextBiz(new Date(today.getTime() + EDAY));
        var date = addBiz(processDay, maxDays);
        var missed = addBiz(nextBiz(new Date(processDay.getTime() + EDAY)), maxDays);
        var left = processDay.getTime() + cutMin * 60000 - eTzMs - now, html;
        if (missed.getTime() > date.getTime() && left > 0 && left <= EDAY) {
          var h = Math.floor(left / 3600000), m = Math.floor(left % 3600000 / 60000), parts = [];
          if (h > 0) parts.push(h + ' ' + (h === 1 ? T('pdp_hr', 'hr') : T('pdp_hrs', 'hrs')));
          parts.push(m + ' ' + (m === 1 ? T('pdp_min', 'min') : T('pdp_mins', 'mins')));
          html = T('pdp_order_within', 'Order within {time}, get it by {date}').replace('{time}', '<b>' + parts.join(' ') + '</b>').replace('{date}', '<b>' + fmt(date) + '</b>');
        } else html = T('pdp_order_now', 'Order now, get it by {date}').replace('{date}', '<b>' + fmt(date) + '</b>');
        if (etaText.innerHTML !== html) etaText.innerHTML = html;
      };
      if (skip.length < 7) { renderEta(); setInterval(renderEta, 5000); }
    }

    /* ---- battery add-on: price chip follows the chosen pack; choosing a pack ticks the box (live behaviour) ---- */
    /* ---- gift chips (Variant B): toggle; the card chip opens the message field ---- */
    if (gift) gift.addEventListener('click', function (e) {
      var c = e.target.closest('[data-gift-opt]'); if (!c) return;
      var on = c.getAttribute('aria-pressed') !== 'true';
      c.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (c.getAttribute('data-gift-opt') === 'card') { var m = gift.querySelector('[data-gift-msg]'); if (m) { m.hidden = !on; if (on) m.focus(); } }
    });
    if (batt && batt.querySelector('[data-batt-variant]')) {
      var bSel = batt.querySelector('[data-batt-variant]'), bBox = batt.querySelector('[data-batt]'), bPrice = batt.querySelector('[data-batt-price]');
      var bPaint = function () { var o = bSel.options[bSel.selectedIndex]; if (o && bPrice) bPrice.textContent = '+' + money(+o.getAttribute('data-price')); };
      bSel.addEventListener('change', function () { bPaint(); bBox.checked = true; });
      bPaint();
    }

    /* ---- share: native share sheet where it exists, else copy the link (live behaviour) ---- */
    var shareBtn = root.querySelector('[data-share]');
    if (shareBtn) shareBtn.addEventListener('click', function () {
      var url = location.href, title = shareBtn.getAttribute('data-share-title') || document.title;
      var done = function () { if (CL.toast) CL.toast(T('pdp_link_copied', 'Link copied')); };
      var legacy = function () { try { var t = document.createElement('textarea'); t.value = url; t.setAttribute('readonly', ''); t.style.cssText = 'position:fixed;top:-1000px;opacity:0'; document.body.appendChild(t); t.select(); var ok = document.execCommand('copy'); t.remove(); if (ok) done(); else if (CL.toast) CL.toast(T('pdp_copy_link', 'Copy this link:') + ' ' + url); } catch (e) {} };
      if (navigator.share) { navigator.share({ title: title, url: url }).catch(function () {}); return; }
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, legacy); else legacy();
    });

    /* ---- photo zoom: hover magnifier (desktop) + full-screen viewer (live: enable_image_zoom / enable_hover_zoom) ---- */
    var imgs = slides.filter(function (el) { return el.tagName === 'IMG' && el.getAttribute('data-zoom'); });
    var mag = root.querySelector('[data-mag]');
    if (mag && data.hoverZoom && s && matchMedia('(hover: hover) and (pointer: fine)').matches) {
      var Z = +data.zoomLevel || 2.5, galEl = root.querySelector('.gal');
      var magOff = function () { mag.hidden = true; };
      s.addEventListener('mousemove', function (e) {
        if (innerWidth < 860) return magOff();
        var img = slides[idx()];
        if (!img || img.tagName !== 'IMG' || !img.naturalWidth) return magOff();
        var box = img.getBoundingClientRect(), g = galEl.getBoundingClientRect();
        var r = Math.min(box.width / img.naturalWidth, box.height / img.naturalHeight), cw = img.naturalWidth * r, ch = img.naturalHeight * r;
        var cl = box.left + (box.width - cw) / 2, ct = box.top + (box.height - ch) / 2;
        if (e.clientX < cl || e.clientX > cl + cw || e.clientY < ct || e.clientY > ct + ch) return magOff();
        var big = img.getAttribute('data-zoom');
        if (mag.getAttribute('data-src') !== big) { mag.setAttribute('data-src', big); mag.style.backgroundImage = 'url("' + big + '")'; }
        mag.style.left = (box.left - g.left) + 'px'; mag.style.top = (box.top - g.top) + 'px';
        mag.style.width = box.width + 'px'; mag.style.height = box.height + 'px';
        mag.style.backgroundSize = (cw * Z) + 'px ' + (ch * Z) + 'px';
        var mx = e.clientX - box.left, my = e.clientY - box.top;
        mag.style.backgroundPosition = (mx - (e.clientX - cl) * Z) + 'px ' + (my - (e.clientY - ct) * Z) + 'px';
        mag.hidden = false;
      });
      s.addEventListener('mouseleave', magOff);
      s.addEventListener('scroll', magOff, { passive: true });
    }
    if (data.zoom && imgs.length) {
      var lb = null, lbTrack, lbCount, lbI = 0, lastFocus;
      var lbIdx = function () { return lbTrack.clientWidth ? Math.round(lbTrack.scrollLeft / lbTrack.clientWidth) : 0; };
      var lbLoad = function (i) { [i - 1, i, i + 1].forEach(function (k) { var im = lbTrack.children[k] && lbTrack.children[k].firstChild; if (im && !im.src) im.src = im.getAttribute('data-src'); }); };
      var lbMark = function () { lbI = lbIdx(); if (lbCount) lbCount.textContent = (lbI + 1) + ' / ' + imgs.length; lbCount.setAttribute('dir', 'ltr'); lbLoad(lbI); };
      var lbGo = function (i, smooth) { i = Math.max(0, Math.min(imgs.length - 1, i)); lbTrack.scrollTo({ left: lbTrack.clientWidth * i, behavior: smooth && !reduce ? 'smooth' : 'auto' }); lbI = i; lbMark(); };
      var lbClose = function () { if (!lb || lb.hidden) return; lb.hidden = true; document.documentElement.classList.remove('cl10-lb-open'); lbTrack.querySelectorAll('img.z').forEach(function (z) { z.classList.remove('z'); }); if (lastFocus) lastFocus.focus(); };
      var lbBuild = function () {
        lb = document.createElement('div'); lb.className = 'cl10-lb'; lb.hidden = true;
        lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.setAttribute('aria-label', T('pdp_photos_of', '{title} photos').replace('{title}', data.title || T('pdp_product', 'Product')));
        var esc = function (t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
        lb.innerHTML = '<div class="cl10-lb-head"><b dir="auto">' + esc(data.title || '') + '</b><span data-lb-count></span><button type="button" class="cl10-lb-x" data-lb-close aria-label="' + esc(T('pdp_close_viewer', 'Close photo viewer')) + '"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg></button></div>'
          + '<div class="cl10-lb-track" data-lb-track>' + imgs.map(function (im) { return '<div><img alt="' + esc(im.alt || '') + '" data-src="' + esc(im.getAttribute('data-zoom')) + '" draggable="false"></div>'; }).join('') + '</div>'
          + (imgs.length > 1 ? '<button type="button" class="cl10-lb-nav cl10-lb-prev" data-lb-prev aria-label="' + esc(T('pdp_prev_photo', 'Previous photo')) + '"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg></button><button type="button" class="cl10-lb-nav cl10-lb-next" data-lb-next aria-label="' + esc(T('pdp_next_photo', 'Next photo')) + '"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg></button>' : '');
        document.body.appendChild(lb);
        lbTrack = lb.querySelector('[data-lb-track]'); lbCount = lb.querySelector('[data-lb-count]');
        var t = false;
        lbTrack.addEventListener('scroll', function () { if (t) return; t = true; requestAnimationFrame(function () { t = false; lbMark(); }); }, { passive: true });
        lb.querySelector('[data-lb-close]').addEventListener('click', lbClose);
        var pv = lb.querySelector('[data-lb-prev]'), nx = lb.querySelector('[data-lb-next]');
        if (pv) pv.addEventListener('click', function () { lbGo(lbI - 1, true); });
        if (nx) nx.addEventListener('click', function () { lbGo(lbI + 1, true); });
        lbTrack.addEventListener('click', function (e) {
          var im = e.target.closest('img');
          if (!im) { lbClose(); return; }
          if (im.classList.contains('z')) { im.classList.remove('z'); return; }
          var r = im.getBoundingClientRect(); im.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%'; im.classList.add('z');
        });
        lb.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') { e.preventDefault(); lbClose(); }
          else if (e.key === 'ArrowRight') { e.preventDefault(); lbGo(lbI + 1, true); }
          else if (e.key === 'ArrowLeft') { e.preventDefault(); lbGo(lbI - 1, true); }
          else if (e.key === 'Tab') { var f = lb.querySelectorAll('button'); if (!f.length) return; var a = f[0], z = f[f.length - 1]; if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); } else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); } }
        });
      };
      var lbOpen = function (i) {
        if (!lb) lbBuild();
        lastFocus = document.activeElement; mag && (mag.hidden = true);
        lb.hidden = false; document.documentElement.classList.add('cl10-lb-open');
        lbGo(i, false); lb.querySelector('[data-lb-close]').focus();
        if (CL.track) CL.track('pdp_photo_zoom', { product: data.title });
      };
      if (s) {
        var downX = 0, downY = 0;
        s.addEventListener('pointerdown', function (e) { downX = e.clientX; downY = e.clientY; }, { passive: true });
        s.addEventListener('click', function (e) {
          var im = e.target.closest('img[data-zoom]'); if (!im) return;
          if (Math.abs(e.clientX - downX) > 8 || Math.abs(e.clientY - downY) > 8) return; /* a swipe, not a tap */
          lbOpen(Math.max(0, imgs.indexOf(im)));
        });
        s.addEventListener('keydown', function (e) { if (e.key === 'Enter') { var im = slides[idx()]; if (im && imgs.indexOf(im) > -1) { e.preventDefault(); lbOpen(imgs.indexOf(im)); } } });
      }
    }

    /* ---- sold out: Notify me -> Simpll back-in-stock modal (Simpll replaces [name=add]); WhatsApp fallback ---- */
    var notify = document.querySelectorAll('[data-pdp-notify]');
    if (notify.length) {
      var soldBtn = form && form.querySelector('[data-pdp-buy]');
      var simpll = null;
      var pending = null, pendingT = 0;
      function adopt(b) {
        simpll = b; b.classList.add('cl10-hide');
        if (soldBtn) soldBtn.style.display = '';
        if (pending) { clearTimeout(pendingT); pending.removeAttribute('aria-busy'); pending = null; b.click(); }
      }
      var obs = new MutationObserver(function () { var b = document.querySelector('.slw-notify-btn'); if (b && b !== simpll) adopt(b); });
      obs.observe(document.body, { childList: true, subtree: true });
      var b0 = document.querySelector('.slw-notify-btn'); if (b0) adopt(b0);
      notify.forEach(function (n) {
        n.addEventListener('click', function () {
          if (simpll) { simpll.click(); return; }
          /* Simpll mounts a few seconds after load: wait up to 5 s for it, then fall back to WhatsApp */
          if (pending) return;
          pending = n; n.setAttribute('aria-busy', 'true');
          pendingT = setTimeout(function () {
            n.removeAttribute('aria-busy'); pending = null;
            if (data.wa) window.open('https://wa.me/' + data.wa + '?text=' + encodeURIComponent(data.notifyFallback || ''), '_blank', 'noopener');
          }, 5000);
        });
      });
    }

    /* ---- analytics: which alternative relation earns clicks (spec §11) ---- */
    root.querySelectorAll('[data-alts] .alt').forEach(function (a) { a.addEventListener('click', function () { if (CL.track) CL.track('alt_strip_click', { relation: a.getAttribute('data-rel') }); }); });
    var sd = root.querySelector('[data-sameday]');
    if (sd) sd.addEventListener('click', function () {
      if (CL.track) CL.track('same_day_whatsapp_click', { product: data.title });
      /* same events as the live clt-sdd card: Meta Contact + gtag */
      try {
        if (typeof window.fbq === 'function') window.fbq('track', 'Contact', { content_name: data.title });
        if (typeof window.gtag === 'function') window.gtag('event', 'same_day_whatsapp_click', { item_name: data.title });
      } catch (e) {}
    });

    /* ---- reviews: "Write a review" opens the Judge.me form when the widget is there ---- */
    document.querySelectorAll('[data-write-review]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var w = document.querySelector('.jdgm-write-rev-link');
        if (w) { e.preventDefault(); w.click(); w.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); }
      });
    });

    /* ---- recently viewed (device only) ---- */
    var rec = document.querySelector('[data-recent]');
    if (rec && CL.recent && CL.renderHandles) {
      var hs = CL.recent().filter(function (h) { return h !== data.handle; }).slice(0, +rec.getAttribute('data-limit') || 8);
      if (hs.length) CL.renderHandles(rec.querySelector('[data-recent-rail]'), hs, 'cl10-mini').then(function (n) { if (n) rec.hidden = false; });
    }
  }
  /* cl10.js (window.CL) is deferred after this file, so wait for it unless it is already there */
  if (window.CL && window.CL.money) start();
  else { document.addEventListener('DOMContentLoaded', start); addEventListener('load', start); }
})();
